export default __webpack_public_path__ + "static/PromptIconSeven-dc11a43fbc00451aa2e84975cdff4970.png";